import { ACTIONS } from '../constants/inventory';

const INITIAL_STATE = {
  inventoryVariantsList: { variants: [], params: {}, pager: null, error: null, loading: false },
  inventoryLocationsList: { locations: [], error: null, loading: false },
  inventoryTransferCreate: { transfer: null, error: null, loading: false },
};

export const inventory = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    //================================== INVENTORY VARIANTS FETCH START ==================================//
    case ACTIONS.INVENTORY_VARIANTS_FETCH_START:
      return {
        ...state,
        inventoryVariantsList: {
          variants: [],
          params: action.payload,
          pager: null,
          error: null,
          loading: true,
        },
      };
    case ACTIONS.INVENTORY_VARIANTS_FETCH_SUCCESS:
      return {
        ...state,
        inventoryVariantsList: {
          ...state.inventoryVariantsList,
          variants: action.payload.results || action.payload,
          pager: action.payload.paginator || null,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.INVENTORY_VARIANTS_FETCH_FAILURE:
      return {
        ...state,
        inventoryVariantsList: {
          ...state.inventoryVariantsList,
          variants: [],
          pager: null,
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.INVENTORY_VARIANTS_FETCH_RESET:
      return {
        ...state,
        inventoryVariantsList: {
          variants: [],
          params: null,
          pager: null,
          error: null,
          loading: false,
        },
      };
    //==================================  INVENTORY VARIANTS FETCH END  ==================================//

    //================================== INVENTORY LOCATIONS FETCH START ==================================//
    case ACTIONS.INVENTORY_LOCATIONS_FETCH_START:
      return {
        ...state,
        inventoryLocationsList: {
          locations: [],
          error: null,
          loading: true,
        },
      };
    case ACTIONS.INVENTORY_LOCATIONS_FETCH_SUCCESS:
      return {
        ...state,
        inventoryLocationsList: {
          ...state.inventoryLocationsList,
          locations: action.payload.results || action.payload,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.INVENTORY_LOCATIONS_FETCH_FAILURE:
      return {
        ...state,
        inventoryLocationsList: {
          ...state.inventoryLocationsList,
          locations: [],
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.INVENTORY_LOCATIONS_FETCH_RESET:
      return {
        ...state,
        inventoryLocationsList: {
          locations: [],
          error: null,
          loading: false,
        },
      };
    //==================================  INVENTORY LOCATIONS FETCH END  ==================================//

    //================================== INVENTORY TRANSFER CREATE START ==================================//
    case ACTIONS.INVENTORY_TRANSFER_CREATE_START:
      return {
        ...state,
        inventoryTransferCreate: {
          transfer: action.payload,
          error: null,
          loading: true,
        },
      };
    case ACTIONS.INVENTORY_TRANSFER_CREATE_SUCCESS:
      return {
        ...state,
        inventoryTransferCreate: {
          transfer: action.payload,
          error: null,
          loading: false,
        },
      };
    case ACTIONS.INVENTORY_TRANSFER_CREATE_FAILURE:
      return {
        ...state,
        inventoryTransferCreate: {
          transfer: null,
          error: action.payload,
          loading: false,
        },
      };
    case ACTIONS.INVENTORY_TRANSFER_CREATE_RESET:
      return {
        ...state,
        inventoryTransferCreate: {
          transfer: null,
          error: null,
          loading: false,
        },
      };
    //==================================  INVENTORY TRANSFER CREATE END  ==================================//

    default:
      return state;
  }
};
